module.exports = __webpack_public_path__ + "static/media/jakarta-utara.6918348b.svg";